import { chain, find, map } from 'lodash';
import { ICombine, IConditionDetail } from '@app/shared';
import { PrePaiement } from './pre-paiement.model'
import { NoShow } from './no-show.model'
import { Annulation } from './annulation.model'
import { Ota } from './ota.model'

export class AvailLine {
    id: number;
    isDispo: boolean;
    stock: number;
    occupation: string;
    indexSearch: string;
    categorie: number;
    offre_site: Array<any>;
    conditiondetail: IConditionDetail;
    price: number;
    garantie: boolean;
    taxe: {
        'new': { Ttc: number; Sale: number; HT: number; TaxeExc: number; TaxeInc: number; details?: any; Taxes?: any },
        old: { Ttc: number; Sale: number; HT: number; TaxeExc: number; TaxeInc: number; details?: any; Taxes?: any },
    };

    constructor(data) {
        this.id = parseInt(data.id);
        this.isDispo = data.isDispo;
        this.stock = data.stock;
        this.occupation = data.occupation;
        this.indexSearch = !!data.indexSearch ? data.indexSearch : ''.concat(data.occupation, '_1_o');
        this.categorie = data.categorie;
        this.offre_site = data.offre_site;
        this.conditiondetail = data.conditiondetail;
        this.price = data.price;
        this.garantie = data.garantie;
        this.taxe = data.taxe;
    }

    /**
     * converte AvailLine to ICombine
     * @returns ICombine
     */
    toCombine(): ICombine {
        let combine: ICombine = {
            indexSearch: '',
            alias: 'w',
            uid: '',
            serial: '',
            ota: 'local',
            snapshoot: false,
            isGoogleHotelAds: false,
            is_partner: false,
            detailPrice: this.taxe.new,
            detailPrice_without_promo: this.taxe.old,
            promo_iq: 0,//TODO: calculer percente (new.Ttc old.Ttc)
            ttc: this.taxe.new.Ttc,
            stock: this.stock,
            garantie: this.garantie,
            ocupation: this.occupation,
            plusadult: 0,
            code_occupancy: 2,
            code_children: 0,
            priceByAdult: {},
            conditiondetail: this.conditiondetail,
            PrePaiement: (new PrePaiement()).bindingData(this.conditiondetail),
            noShow: (new NoShow()).bindingData(this.conditiondetail),
            annulation: (new Annulation()).bindingData(this.conditiondetail),
            price_html: '',
            addedvalues: [],
            child: parseInt(this.occupation.split('_')[1]),
            hbnet: 0,
            ltId: 0,
            room_upgrade: 0,
            offer_freebreakfast: true,
            roomtype_ota: {
                room_name: ''
            },
            room_upgrade_to: '',
            metrage: '',
        };
        combine.priceByAdult[this.occupation.split('_')[0]] = {
            detailPrice: combine.detailPrice,
            detailPrice_without_promo: combine.detailPrice_without_promo,
        }
        return combine;
    }
}

export class AvailRoom {
    id: number;
    stock: number;
    taxe: {
        exc: {}//[Array<{txFormule: number, txInc: boolean, txIssejour: boolean, txMontant: number, txMontantDisplay: number, txName: string, txTypeMontant: number, txdId: number}>],
        , inc: {}//[Array<{txFormule: number, txInc: boolean, txIssejour: boolean, txMontant: number, txMontantDisplay: number, txName: string, txTypeMontant: number, txdId: number}>]
    };
    lines: Array<AvailLine> = [];

    constructor(data) {
        this.id = parseInt(data.id);
        this.stock = data.stock;
        this.taxe = data.taxe;
        for (let l of data.lines) {
            if (!l.taxe.new.details) l.taxe.new.details = data.taxe;
            if (!l.taxe.old.details) l.taxe.old.details = data.taxe;
            let newL = new AvailLine(l);
            this.lines.push(newL);
        }
    }

    /**
     * find line by id
     * @param intger id line
     * @returns AvailLine|undefined
     */
    public findLine(id): AvailLine {
        return find(this.lines, { id: id })
    }
}


export class Availibility {
    rooms: Array<AvailRoom> = [];
    extraDispo: Ota;

    constructor(data) {
        for (let r of data.rooms) {
            let newR = new AvailRoom(r);
            this.rooms.push(newR);
        }
        if (!!data.extraDispo) {
            this.extraDispo = new Ota(data.extraDispo, 'extraData');
        }
    }

    /**
     * find room by id
     * @param intger id room
     * @returns AvailRoom|undefined
     */
    public findRoom(id): AvailRoom {
        return find(this.rooms, { id: parseInt(id) })
    }

    /**
     * find line by id room and id line
     * @param intger id line
     * @returns AvailLine|undefined
     */
    public findLineBy(idRoom, idLine): AvailLine {
        let r = this.findRoom(idRoom);
        if (r) {
            return r.findLine(idLine);
        }
        return undefined;
    }

    /**
     * get min AvailLine
     * @returns AvailLine|null
     */
    public getMinDisp(): AvailLine {
        let dispo = chain(this.rooms).map('lines').flatten().filter({ 'isDispo': true }).minBy('taxe.new.Ttc').value();
        if (dispo != undefined)
            return dispo;
        return null;
    }
}
